import { UrlMatchResult, UrlSegment } from '@angular/router';

export function shortUrlPathMatcher(url: UrlSegment[]): UrlMatchResult | null {
  if (url.length !== 2) {
    return null;
  }

  const [root, id] = url;

  if (root.path.match(/^[reco]$/) && id.path.match(/[a-zA-Z0-9]+/)) {
    return {
      consumed: url,
      posParams: {
        id: new UrlSegment(id.path, { }),
      }
    };
  }

  return null;
}
